import React from 'react';
import PropTypes from 'prop-types';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { ScorecardEditorialReviewBody } from 'site-modules/core-page/components/scorecard-editorial-review/scorecard-editorial-review-body';

import './scorecard-editorial-review.scss';

export function ScorecardEditorialReview({
  vehicle = null,
  hasRouteYearParam = false,
  embeddedModules = null,
  isUsed = false,
  isPreprod = false,
  params,
  showScorecard = true,
  showHighlights = false,
  showBottomHr = true,
  hasTrimsLink = true,
  showTrimsReview = false,
}) {
  return (
    <div className="scorecard-editorial-review">
      <ScorecardEditorialReviewBody
        params={params}
        vehicle={vehicle}
        embeddedModules={embeddedModules}
        hasRouteYearParam={hasRouteYearParam}
        hasTrimsLink={hasTrimsLink}
        showScorecard={showScorecard}
        showHighlights={showHighlights}
        showTrimsReview={showTrimsReview}
        isPreprod={isPreprod}
        isUsed={isUsed}
      />
      {showBottomHr && <hr />}
    </div>
  );
}

ScorecardEditorialReview.propTypes = {
  params: CorePageParams.isRequired,
  vehicle: PropTypes.shape({
    make: PropTypes.shape({
      name: PropTypes.string,
    }),
    model: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  embeddedModules: PropTypes.shape({
    pricingModule: PropTypes.node,
    coreSrpModule: PropTypes.node,
    newsModule: PropTypes.node,
  }),
  hasRouteYearParam: PropTypes.bool,
  isUsed: PropTypes.bool,
  isPreprod: PropTypes.bool,
  showScorecard: PropTypes.bool,
  showHighlights: PropTypes.bool,
  showBottomHr: PropTypes.bool,
  hasTrimsLink: PropTypes.bool,
  showTrimsReview: PropTypes.bool,
};
